export default __webpack_public_path__ + "static/media/40t.bee2b790.jpg";